export const withUseQuery = async <T>(apiCall: () => Promise<[T, boolean]>): Promise<T> => {
  const [data, error] = await apiCall();
  if (error) throw Error;

  return data;
};
